import Vue from 'vue'
import Vuex from 'vuex'
import * as db from '@/plugins/db'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    nameList: [] as any,
    nameListLoading: false,
    attendanceLoading: false,
    attendance: {} as any,
    currentDate: new Date().toISOString().substr(0, 10)
  },
  mutations: {
    nameListUpdate (state, payload) {
      state.nameList = payload
    },
    nameListAdd (state, payload) {
      state.nameList.push(payload)
    },
    nameListLoading (state, payload) {
      state.nameListLoading = payload
    },
    attendanceLoading (state, payload) {
      state.attendanceLoading = payload
    },
    attendanceInit (state, payload) {
      Vue.set(state.attendance, payload, {})
    },
    attendanceUpdate (state, { date, users }) {
      Vue.set(state.attendance, date, users)
    },
    attendanceAdd (state, { date, user }) {
      Vue.set(state.attendance[date], user.id, user)
    },
    attendanceRemove (state, { date, user }) {
      Vue.delete(state.attendance[date], user)
    },
    setCurrentDate (state, payload) {
      state.currentDate = payload
    }
  },
  actions: {
    async getNameList ({ commit }) {
      commit('nameListLoading', true)
      const nameList = await db.findName()
      commit('nameListUpdate', nameList.data)
      commit('nameListLoading', false)
    },
    async editNameList ({ commit, dispatch }, payload) {
      commit('nameListLoading', true)
      if (payload.id > -1) {
        await db.addName(payload.item, payload.id.toString())
      } else {
        await db.addName(payload.item)
      }
      dispatch('getNameList')
    },
    async deleteName ({ commit, dispatch }, payload) {
      commit('nameListLoading', true)
      await db.deleteName(payload)
      dispatch('getNameList')
    },
    async selectDate ({ commit }, date) {
      commit('attendanceLoading', true)
      const res = await db.findAttendance(date)
      if (res.data) {
        commit('attendanceInit', date)
        console.log('[INFO] Result:', res.data)
        const users = res.data
        for (const user of users) {
          commit('attendanceAdd', { date, user })
        }
      }
      commit('attendanceLoading', false)
    },
    async addAttendance ({ commit }, { date, user }) {
      commit('attendanceLoading', true)
      commit('attendanceAdd', { date, user })
      try {
        await db.addAttendance(date, user.id)
      } catch (e) {
        commit('attendanceRemove', { date, user: user.id })
      }
      commit('attendanceLoading', false)
    },
    async deleteAttendance ({ commit, state }, { date, user }) {
      commit('attendanceLoading', true)
      const userObj = state.attendance[date][user]
      commit('attendanceRemove', { date, user })
      const result = await db.deleteAttendance(date, user)
      console.log(result.data)
      if (result.data < 1) {
        commit('attendanceAdd', { date, user: userObj })
      }
      commit('attendanceLoading', false)
    }
  },
  modules: {
  }
})
